import store from "@/store";

window.messages = require("./common/messages").default;
window.$_ = require("jquery").noConflict();
window.http = require("./common/HttpRequest").default;
require("bootstrap-v4-rtl");
require("bootstrap-select");
require("pusher-js");
store.dispatch("setAuthorized");
